module.exports = __webpack_public_path__ + "static/assets/651275fc77d16a2586317749c28bb799.png";